function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgLexikonAvacon = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 50 50",
    xmlSpace: "preserve",
    xmlnsserif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round"
    },
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("path", {
    id: "lexikon_avacon",
    d: "M35.57,39.245L14.489,39.245L14.489,10.8L29.449,10.8L34.891,16.788L34.891,35.505M17.887,19.783L22.82,19.783M17.887,25.77L30.215,25.77M17.887,29.513L30.215,29.513M29.449,10.8L29.449,16.788L34.891,16.788",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "white",
      strokeWidth: "1.73px"
    }
  }));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgLexikonAvacon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/lexikon_avacon.b332be05.svg";
export { ForwardRef as ReactComponent };